import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {routes} from "../routes";
import {FaCircleArrowRight} from "react-icons/fa6";
import GiftModal from "./GiftModal";

export const cardData = [
    {
        title: 'Código de\nvestimenta',
        image: '/images/Grid-Dress.png',
        path: routes.DressCode,
        enabled: true,
        prox: '/images/Prox2.png'
    },
    {
        title: 'Consideraciones\nespeciales',
        image: '/images/Grid-Transporte.png',
        path: routes.Alcohol,
        enabled: true,
        prox: '/images/Prox4.png'
    },
    {
        title: 'Mesa de\nregalos',
        image: '/images/Grid-MesaRegalos.png',
        path: routes.GiftRegistry,
        enabled: true,
        prox: '/images/Prox3.png'
    },
    {
        title: 'Preguntas\nFrecuentes',
        image: '/images/Grid-FAQ.png',
        path: routes.FAQ,
        enabled: true,
        prox: '/images/Prox1.png'
    }
];

export const ArrowIcon = ({className}: { className: string }) => (
    <div className={className}>
        {FaCircleArrowRight({size: 24})}
    </div>
);

const CardsDisplay: React.FC = () => {
    const [isGiftModalOpen, setIsGiftModalOpen] = useState(false);

    return (
        <section className="py-8 md:py-24 text-white">
            <div
                className="grid grid-cols-4 md:grid-cols-2 grid-rows-12 md:grid-rows-2 md:gap-8 md:place-items-center md:px-20">
                {cardData.map((card) => {
                    const isGiftRegistry = card.path === routes.GiftRegistry;

                    if (!card.enabled) {
                        return (
                            <div key={card.path}
                                 className="grid grid-rows-subgrid grid-cols-subgrid group md:grid-rows-6 col-span-4 md:col-span-1 md:row-span-1 row-span-3 md:place-items-center cursor-not-allowed">
                                <div
                                    className="w-[67svw] md:row-start-1 pl-1 col-span-3 md:col-span-1 row-span-3 md:row-span-5 md:max-w-[30svw] relative">
                                    <img
                                        src={card.image}
                                        alt={card.title}
                                        className="w-full transition-transform duration-500 ease-in-out rounded-2xl filter grayscale"
                                    />
                                    <img
                                        src={card.prox}
                                        alt={card.title + " prox"}
                                        aria-hidden="true"
                                        className="pointer-events-none absolute inset-0 w-full h-full rounded-2xl object-cover"
                                    />
                                </div>
                                <div
                                    className="col-start-4 md:col-start-1 row-start-2 md:row-start-6 bg-(--calendar-color) bg-opacity-40 group-hover:bg-opacity-50 transition-all duration-300 grid grid-rows-2 md:place-content-center -ml-4 w-[33svw]">
                                    <div className="text-left md:text-center whitespace-pre-wrap">{card.title}</div>
                                    <ArrowIcon
                                        className="transition-transform duration-300 grid md:place-content-center"/>
                                </div>
                            </div>
                        );
                    }

                    if (isGiftRegistry) {
                        return (
                            <button
                                key={card.path}
                                onClick={() => setIsGiftModalOpen(true)}
                                className="grid grid-rows-subgrid grid-cols-subgrid group md:grid-rows-6 col-span-4 md:col-span-1 md:row-span-1 row-span-3 md:place-items-center text-white"
                            >
                                <div
                                    className="w-[67svw] md:row-start-1 pl-1 col-span-3 md:col-span-1 row-span-3 md:row-span-5 md:max-w-[30svw] relative text-left">
                                    <img
                                        src={card.image}
                                        alt={card.title}
                                        className="w-full transition-transform duration-500 ease-in-out group-hover:scale-105 rounded-2xl"
                                    />
                                </div>
                                <div
                                    className="col-start-4 md:col-start-1 row-start-2 md:row-start-6 bg-(--calendar-color) bg-opacity-40 group-hover:bg-opacity-50 transition-all duration-300 grid grid-rows-2 md:place-content-center -ml-4 w-[33svw]">
                                    <div className="text-left md:text-center whitespace-pre-wrap">{card.title}</div>
                                    <ArrowIcon
                                        className="transition-transform duration-300 group-hover:translate-x-1 grid md:place-content-center"/>
                                </div>
                            </button>
                        );
                    }

                    return (
                        <Link to={card.path} key={card.path}
                              className="grid grid-rows-subgrid grid-cols-subgrid group md:grid-rows-6 col-span-4 md:col-span-1 md:row-span-1 row-span-3 md:place-items-center">
                            <div
                                className="w-[67svw] md:row-start-1 pl-1 col-span-3 md:col-span-1 row-span-3 md:row-span-5 md:max-w-[30svw] relative">
                                <img
                                    src={card.image}
                                    alt={card.title}
                                    className="w-full transition-transform duration-500 ease-in-out group-hover:scale-105 rounded-2xl"
                                />
                            </div>
                            <div
                                className="col-start-4 md:col-start-1 row-start-2 md:row-start-6 bg-(--calendar-color) bg-opacity-40 group-hover:bg-opacity-50 transition-all duration-300 grid grid-rows-2 md:place-content-center -ml-4 w-[33svw]">
                                <div className="text-left md:text-center whitespace-pre-wrap">{card.title}</div>
                                <ArrowIcon
                                    className="transition-transform duration-300 group-hover:translate-x-1 grid md:place-content-center"/>
                            </div>
                        </Link>
                    );
                })}
            </div>
            <GiftModal
                isOpen={isGiftModalOpen}
                onClose={() => setIsGiftModalOpen(false)}
            />
        </section>
    );
};

export default CardsDisplay;